import { _ as _objectWithoutProperties, a as _extends } from '../_rollupPluginBabelHelpers-b0164b33.js';
import React from 'react';
import PropTypes from 'prop-types';
import Bem from '../packages/honey-bem.js';
import { Injecss } from '../packages/injecss.js';

var styles = {
raw: ".hcr-nav-side-1-6-0,.hcr-nav-side-subnav-1-6-0{position:relative;margin:0;padding:0}.hcr-nav-side--centered-1-6-0{text-align:center}.hcr-nav-side-subnav__item-1-6-0,.hcr-nav-side__item-1-6-0{display:block;position:relative}.hcr-nav-side-subnav__link-1-6-0,.hcr-nav-side__link-1-6-0{display:inline-block;position:relative;width:100%;padding:5px 0;color:#444;font-size:16px;font-weight:400;line-height:1.375em;text-decoration:none;cursor:pointer}.hcr-nav-side-subnav__link-1-6-0:active,.hcr-nav-side-subnav__link-1-6-0:focus,.hcr-nav-side-subnav__link-1-6-0:hover,.hcr-nav-side__link-1-6-0:active,.hcr-nav-side__link-1-6-0:focus,.hcr-nav-side__link-1-6-0:hover{color:#ffad00;text-decoration:none}.hcr-nav-side__link--active-1-6-0{color:#ffad00}.hcr-nav-side__link--has-subnav-1-6-0:after{display:inline-block;width:24px;height:24px;content:\"\";vertical-align:middle;background:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1000 1000'%3E%3Cpath d='M236.4 365.9a28.2 28.2 0 0140.4 0l216.4 216.4a8.2 8.2 0 0013.6 0l216.4-216.4a28.6 28.6 0 0140.4 40.5L545.5 622.7a66.4 66.4 0 01-45.5 19.6 66.4 66.4 0 01-45.5-19.6L236.4 406.4a28.2 28.2 0 010-40.5z' fill='rgba(68, 68, 68, 0.99)'/%3E%3C/svg%3E\") no-repeat 50%}.hcr-nav-side__link--has-subnav-1-6-0.hcr-nav-side__link--active-1-6-0:after,.hcr-nav-side__link--has-subnav-1-6-0:active:after,.hcr-nav-side__link--has-subnav-1-6-0:focus:after,.hcr-nav-side__link--has-subnav-1-6-0:hover:after{background:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1000 1000'%3E%3Cpath d='M236.4 365.9a28.2 28.2 0 0140.4 0l216.4 216.4a8.2 8.2 0 0013.6 0l216.4-216.4a28.6 28.6 0 0140.4 40.5L545.5 622.7a66.4 66.4 0 01-45.5 19.6 66.4 66.4 0 01-45.5-19.6L236.4 406.4a28.2 28.2 0 010-40.5z' fill='rgba(255, 173, 0, 0.99)'/%3E%3C/svg%3E\") no-repeat 50%}.hcr-nav-side__link--has-subnav-open-1-6-0:active:after,.hcr-nav-side__link--has-subnav-open-1-6-0:after,.hcr-nav-side__link--has-subnav-open-1-6-0:focus:after,.hcr-nav-side__link--has-subnav-open-1-6-0:hover:after{-webkit-transform:rotate(180deg);transform:rotate(180deg)}.hcr-nav-side-subnav-1-6-0{padding-left:12px}.hcr-nav-side-subnav__link--active-1-6-0{color:#ffad00}",
map:{"hcr-nav-side":"hcr-nav-side-1-6-0","hcr-nav-side-subnav":"hcr-nav-side-subnav-1-6-0","hcr-nav-side--centered":"hcr-nav-side--centered-1-6-0","hcr-nav-side__item":"hcr-nav-side__item-1-6-0","hcr-nav-side-subnav__item":"hcr-nav-side-subnav__item-1-6-0","hcr-nav-side__link":"hcr-nav-side__link-1-6-0","hcr-nav-side-subnav__link":"hcr-nav-side-subnav__link-1-6-0","hcr-nav-side__link--active":"hcr-nav-side__link--active-1-6-0","hcr-nav-side__link--has-subnav":"hcr-nav-side__link--has-subnav-1-6-0","hcr-nav-side__link--has-subnav-open":"hcr-nav-side__link--has-subnav-open-1-6-0","hcr-nav-side-subnav__link--active":"hcr-nav-side-subnav__link--active-1-6-0"}};

var bem = Bem('nav-side', styles);
var bemSub = Bem('nav-side-subnav', styles);
var NavSide = function NavSide(_ref) {
  var children = _ref.children,
      content = _ref.content,
      extraClasses = _ref.extraClasses,
      rest = _objectWithoutProperties(_ref, ["children", "content", "extraClasses"]);

  var navItems = content || children; // renders navigation elements for both nav and subnav parts since they preserve similar logic

  var buildNavigation = function buildNavigation(items, bemInstance, extraClassNames) {
    return React.createElement("ul", _extends({
      className: bemInstance.b(false, extraClassNames)
    }, rest), items.map(function (_ref2) {
      var text = _ref2.text,
          subChildren = _ref2.children,
          href = _ref2.href,
          active = _ref2.active,
          open = _ref2.open,
          RouterLink = _ref2.RouterLink,
          key = _ref2.key,
          restChild = _objectWithoutProperties(_ref2, ["text", "children", "href", "active", "open", "RouterLink", "key"]);

      return React.createElement("li", {
        className: bemInstance.e('item'),
        key: key || text
      }, !subChildren // no sub nav elements provided, rendering a single link
      && ( // @todo review if there is a need in rendering spans

      /* eslint-disable no-nested-ternary */
      // here this makes code easier to read
      RouterLink ? React.createElement(RouterLink, _extends({
        to: href,
        className: bemInstance.e('link'),
        activeClassName: bemInstance.e('link', {
          active: true
        })
      }, restChild), text) : href ? React.createElement("a", _extends({
        className: bemInstance.e('link', {
          active: active
        }),
        href: href
      }, restChild), text) : React.createElement("span", _extends({
        className: bemInstance.e('link', {
          active: active
        })
      }, restChild), text)), subChildren && React.createElement(React.Fragment, null, href ? React.createElement("a", _extends({
        className: bemInstance.e('link', {
          active: active,
          'has-subnav': subChildren,
          'has-subnav-open': open
        }),
        href: href
      }, restChild), text) : React.createElement("span", _extends({
        className: bemInstance.e('link', {
          'has-subnav': subChildren,
          'has-subnav-open': open
        })
      }, restChild), text), buildNavigation(subChildren, bemSub, null)));
    }));
  };

  return buildNavigation(navItems, bem, extraClasses);
};
NavSide.displayName = 'NavSide';
NavSide.defaultProps = {
  extraClasses: '',
  children: [],
  content: null
};
var contentProps = PropTypes.arrayOf(PropTypes.shape({
  text: PropTypes.node.isRequired,
  href: PropTypes.string,
  key: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  active: PropTypes.bool,
  open: PropTypes.bool,
  RouterLink: PropTypes.oneOfType([PropTypes.func, PropTypes.object])
})); // ugly but spares code, same validation for children

contentProps.children = contentProps;
NavSide.propTypes = {
  /** Injection in className */
  extraClasses: PropTypes.string,

  /** Nav items */
  children: contentProps,

  /** Nav items */
  content: contentProps // @todo deprecate content prop

};
var navSide = Injecss(NavSide, styles);

export { navSide as NavSide };
